export const UTM_SOURCE = 'chatbotweb';
export const UTM_MEDIUM = 'web';
